var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpresource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.30469 1.5625C7.16406 1.32812 6.8125 1.32812 6.67188 1.5625L5.24219 4H8.73438L7.30469 1.5625ZM3.48438 7H10.4922L9.17969 4.75H4.79688L3.48438 7ZM3.0625 7.75L2.07812 9.4375C1.91406 9.69531 2.10156 10 2.38281 10H11.5938C11.875 10 12.0625 9.69531 11.8984 9.4375L10.9375 7.75H3.0625ZM6.01562 1.1875C6.46094 0.4375 7.51562 0.4375 7.96094 1.1875L12.5547 9.0625C13 9.8125 12.4609 10.75 11.5938 10.75H2.38281C1.51562 10.75 0.976562 9.8125 1.42188 9.0625L6.01562 1.1875Z",
    fill: "#2AAD8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 826,
    height: 634,
    fill: "white",
    transform: "translate(-66 -49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpresource);
export default __webpack_public_path__ + "static/media/cpresource.05c12bc19e191e9e978f22dd74fa5787.svg";
export { ForwardRef as ReactComponent };